import {
  Indicator,
  IndicatorContainer,
} from './styles/SkillsLevelIndicator.styled';

interface SkillsLevelIndicatorProps {
  level: string;
}

export const SkillsLevelIndicator = ({ level }: SkillsLevelIndicatorProps) => {
  switch (level) {
    case '1':
      return (
        <IndicatorContainer>
          <Indicator isEnabled />
          <Indicator />
          <Indicator />
        </IndicatorContainer>
      );
    case '2':
      return (
        <IndicatorContainer>
          <Indicator isEnabled />
          <Indicator isEnabled />
          <Indicator />
        </IndicatorContainer>
      );
    case '3':
      return (
        <IndicatorContainer>
          <Indicator isEnabled />
          <Indicator isEnabled />
          <Indicator isEnabled />
        </IndicatorContainer>
      );
    default:
      return (
        <IndicatorContainer>
          <Indicator />
          <Indicator />
          <Indicator />
        </IndicatorContainer>
      );
  }
};
